import { z } from 'zod';

export const exportPdfEvaluationSessionSchema = z.object({
  evaluation_session_id: z.uuid(),
});

export type ExportPdfEvaluationSessionPayload = z.infer<typeof exportPdfEvaluationSessionSchema>;

export interface ExportPdfEvaluationSessionResponse {
  html_content: string;
  download_url: string;
}
